import { isFunction } from 'lodash'

import { CardType, CategoryType } from 'types/deck'

export type FileHandler = (deck: CardType[], categoryMap: Record<string, CategoryType>) => any

/**
 * This function opens a download window for the user.
 *
 * TODO - This might be best used by pulling it out to it's own factory or something spoopy
 * if we ever need to be doing lots of other download. I think for now this is more than fine
 * here since we're only using it here.
 *
 * @param {*} filename - Name of the file to download. This can be change by the downloader, this is just the defautlt
 * @param {*} text - The body of the file.
 */
export const download = (filename: string, text: string) => {
  const body = document.body
  if (body) {
    let element = document.createElement('a')
    element.setAttribute('href', 'data:pdf/plain;charset=utf-8,' + encodeURIComponent(text))
    element.setAttribute('download', filename)
    element.style.display = 'none'
    body.appendChild(element)
    element.click()
    body.removeChild(element)
  }
}

/**
 * This function creates the exported file for downloading a deck by using the supplied `fileCreator`
 * to construct a string that gets dumped to a file.
 *
 * @param {Array<CardType>} deck - The cards in the deck
 * @param {string} fileName - Name of the file (as a default) to get downloaded
 * @param {Function} fileCreator - this is the function that builds the body of the file being exported
 */
export function handleDeckExportDownload(
  deck: Array<any>,
  categories: Record<string, CategoryType>,
  fileName: string,
  fileCreator: FileHandler | null,
) {
  if (!isFunction(fileCreator)) {
    console.error('How do you expect me to build a file without a file creator?')
    return
  }

  const file = fileCreator(deck, categories)

  download(fileName, file)
}
